import React, { useEffect } from 'react'
import { styled } from '@mui/material';
import { Dialog, DialogTitle } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { addLunch } from 'slices/citySlice';
import { fetchLunchSchedule } from 'slices/citySlice';
import toast from "react-hot-toast";
import ErrorMessage from 'components/common/ErrorMessage';
import moment from 'moment';
import axios from 'axios'; // for API calls 
import { useDispatch, useSelector } from 'react-redux';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-container': {
    overflowY: "auto",
    margin: "auto",
    alignItems: "flex-start",
  },
  '& .MuiPaper-root': {
    maxHeight: "none",
    overflowY: "hidden",
    borderRadius: 20
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    backgroundColor: "red"
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    backgroundColor: "red"
  },
}));

const AddLunchSheduleModal = ({ item, onClose, show }) => {
  const dispatch = useDispatch();
  const { lunchSchedule } = useSelector((state) => state.city);
  const methods = useForm({
    defaultValues: {
      start_time: "",
      end_time: "",
    }
  });

  const { control, setValue, handleSubmit, formState: { errors } } = methods;

  useEffect(() => {
  if (show) {
    dispatch(fetchLunchSchedule(false, true)).then((res) => {
      if (res?.data) {
        setValue("start_time", res.data.start_time || "");
        setValue("end_time", res.data.end_time || "");
      }
    });
  }
}, [show, dispatch, setValue]);
  const onSubmit = async (data) => {
  dispatch(addLunch(data, (success, message) => {
      if (success) {
        onClose();
        toast.success(message, {
          className: "successToast",
        });
      } else {
        toast.error(message || "Something went wrong", {
          className: "errorToast",
        });
      }
    }));
  };


  return (
    <BootstrapDialog
      fullWidth
      maxWidth="md"
      onClose={onClose}
      open={show}
      sx={{
        '& .MuiDialog-container': { alignItems: "center" },
        '& .MuiPaper-root': { overflowY: "visible" }
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-content full_modal">
          <DialogTitle>
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">
                Lunch Schedule
              </h5>
              <button type="button" className="btn-close" aria-label="Close"
                onClick={() => onClose(item?.id, item?.status)} />
            </div>
          </DialogTitle>

          <div className="modal-body modal_form_body">
            <div className="row-primary row-r">

              {/* Start Time */}
              <div  style={{ margin: "0" }} className="time">
                <h2>Start Time*</h2>
                <Controller
                  name="start_time"
                  control={control}
                  rules={{
                    required: "Please select start time"
                  }}
                  render={({ field }) => (
                   <div style={{ width: "100%" }}>
                      <div className="input-image">
                        <input
                          type="time"
                          {...field}
                          value={field.value || ""}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            const end_time = moment(e.target.value, "HH:mm")
                              .add(30, "minutes")
                              .format("HH:mm");
                            setValue("end_time", end_time);
                          }}
                        />
                        <img src="/images/clock.png" alt="clock" className="custom-icon" />
                      </div>
                      {errors?.start_time?.message && (
                        <ErrorMessage text={errors.start_time.message} />
                      )}
                    </div>
                  )}
                />
              </div>
                  <br />
              {/* End Time */}
               <div  style={{ margin: "0" }} className="time">
                <h2>End Time*</h2>
                <Controller
                  name="end_time"
                  control={control}
                  rules={{
                    required: "Please select end time"
                  }}
                  render={({ field }) => (
                   <div style={{ width: "100%" }}>
                      <div className="input-image">
                        <input
                          type="time"
                          {...field}
                          value={field.value || ""}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                        <img src="/images/clock.png" alt="clock" className="custom-icon" />
                      </div>
                      {errors?.end_time?.message && (
                        <ErrorMessage text={errors.end_time.message} />
                      )}
                    </div>
                  )}
                />
              </div>
            </div>


            <div style={{ marginTop: 20, textAlign: "right" }}>
            <button
              type="button"
              className="main_button Cancle_button"
              style={{ marginRight: 10 }}
              onClick={() => {
                const payload = { start_time: null, end_time: null };
                dispatch(addLunch(payload, (success, message) => {
                  if (success) {
                    toast.success("Schedule cleared successfully!", {
                      className: "successToast",
                    });
                    onClose();
                  } else {
                    toast.error(message || "Something went wrong", {
                      className: "errorToast",
                    });
                  }
                }));
              }}
            >
              Clear
            </button>

            <button type="submit" className="main_button">
              Save Schedule
            </button>
          </div>

          </div>
        </div>
      </form>
    </BootstrapDialog>
  )
}

export default AddLunchSheduleModal;
